<style lang="scss" scoped>
    .buttons{
        content: "";
        background: url('../../assets/img/icon.png');
        display: inline-block;
        color: #01B4EE;
        width: 1.6em;
        height: 1.6em;
    }
    .red{
        color: #F76B59;
        background: #F76B59;
        height: 20px;
        width: 20px;
        border-radius: 20px;
        border: 3px solid rgba(255, 255, 255, 0.8);
    }
    .green{
        color: #25CC99;
        background: #25CC99;
        height: 20px;
        width: 20px;
        border-radius: 20px;
        border: 3px solid rgba(255, 255, 255, 0.8);
    }
</style>
<template>
    <div>
        <private-table class="m-t-20" :columnsList="tableColumns" :dataTable="dataTable"
                       @getPageData="getPageData" pageHide="true"></private-table>
        <Modal
                :title="'输入密码'"
                v-model="userInfo"
                width="500"
                class="baseInfo-modal"
                :styles="{top: '220px'}">
            <Form :label-width="80" ref="addForm" :rules="rules" :model="form">
                <Row :gutter="60">
                    <Col span="24" class="m-t-20">
                    <FormItem label="账号密码" prop="password">
                        <Input type="text" v-model="form.password" placeholder="账号密码"></Input>
                    </FormItem>
                    </Col>
                </Row>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="userInfo = !userInfo">取消</Button>
                <Button type="primary" size="large" @click="asyncOK">确定</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
    import {getDate} from '@/assets/js/index.js';
    import privateTable from '../wit-electric-monitor/private-table.vue';
    // 随机字符串
import getRandVal, {getTime} from '@/assets/js/index';
// 加密
import Base64 from '@/assets/js/base64.js';
import md5 from 'js-md5';
    export default {
        name: 'fp-state',
        props: {
            id: '',
        },
        data() {
            return {
                loginData: {},
                userInfo: false,
                form: {
                    password: '',
                },
                rules: {
                    password: [{required: true, message: '账号密码不能为空', trigger: 'blur'}]
                },
                tableColumns: [
                    {title: '遥信项', key: 'pointName'},
                    {
                        title: '状态', key: 'value', render: (h, params) => {
                            let value = '';
                            if (params.row.value == '0') {
                                value = 'green';
                            } else {
                                value = 'red';
                            }
                            return h('div', {
                                class: [value],
                                style: {
                                    verticalAlign: 'middle'
                                },
                            })
                        }
                    },
                    {
                        title: '变化时间', key: 'valueTime', render: (h, params) => {
                            return h('span', {}, params.row.valueTime != '~' ? getDate(parseInt(params.row.valueTime), 'year') : '~')
                        }
                    },
                    {
                        title: '操作', key: 'type', render: (h, params) => {
                            let html = '';
                            if (params.row.type == '20415' || params.row.type == '20419') {
                                html = h('Icon', {
                                    class: ['colorPrimary', 'font18', 'buttons'],
                                    style: {
                                        verticalAlign: 'middle'
                                    },
                                    on: {
                                        click: () => {
                                            this.userInfo = true;
                                            this.pointId = params.row.pointId;
                                            this.pointValue = params.row.value;
                                            this.form.password = '';
                                        }
                                    }
                                })
                            }
                            return h('div', {}, [
                                h('a', {}, [
                                    html,
                                ])
                            ]);
                        }
                    },
                ],
                page: {
                    totalCount: 0,
                    pageSize: 10,
                    currentPage: 1
                },
                dataTable: {},
                li: [],
                pointId:'',
                pointValue:'',
            };
        },
        mounted() {
            this.getTable();
            this.loginData = JSON.parse(window.localStorage.getItem('loginData'));
        },
        methods: {
            //获取数据开始
    getPwdHash(pwd, data) {
        var sha = md5(pwd + data);
        var base = new Base64();
        var pwdHashStr = base.encode(sha);
        return pwdHashStr;
    },
            sizeChange(val) {
                this.page.pageSize = val;
                this.getData();
            },//每页条数
            getPageData(val) {
                this.page.currentPage = val;
                this.getData();
            },//分页页数
            getTable() {
                return new Promise((resolve, reject) => {
                    let url = `/mcbw/network_monitor/pointNowValue/${this.id}`;
                    let _this = this;
                    var data = {
                        type: 'get',
                        url: url,
                        obj: {
                            orgId: _this.$store.state.baseInfoLayer.baseInfoId,
                            type: 'zt',
                            pageSize: this.page.pageSize,
                            currentPage: this.page.currentPage,
                        }
                    };
                    _this.$Axios(data).then((res) => {
                        if (res) {
                            this.li = res.data.data;
                            this.page.totalCount = res.data.totalCount;
                            this.dataTable = {
                                list: this.li,
                                page: this.page,
                            }
                        }
                        resolve()
                    }).catch(err => {
                        reject(err)
                    })
                })
            },
            asyncOK () {
                this.$refs['addForm'].validate((valid) => {
                    return new Promise((resolve, reject) => {
                        if (valid) {
                            let url = '/mcbw/business_data/switch_control';
                            let _this = this;
                            var data = {
                                type: 'get',
                                url: url,
                                obj: {
                                    orgId: _this.$store.state.baseInfoLayer.baseInfoId,
                                    pointId: this.pointId,
                                    pointValue: this.pointValue,
                                    passWord: this.form.password,
                                }
                            };
                            _this.$Axios(data).then((response) => {
                                if (response) {
                                    this.userInfo = !this.userInfo;
                                    this.$Message.success(response.data.message)
                                }
                                resolve()
                            }).catch(err => {
                                reject(err)
                            })
                        }
                    })
                })
            },
        },
        watch: {
            id() {
                this.getTable()
            }
        },
        components: {
            privateTable
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/fp/fp-state.vue